import api from './apiSetup';

export const fetchCategories = type => {
  return api(`/categories/${type}/subcategories`);
};

export default {
  fetchCategories
};
